import {Pipe, PipeTransform} from "@angular/core";
import {AvdbSubscription} from "../avdb-subscription";
import {AvdbPricingProduct} from "../database-pricing/avdb-pricing-product";
import {formatDate} from "../database-pricing/date-utils";

export interface SubscriptionStatus {
	isPurchased: boolean,
	autoRenewActive?: boolean,
	endDate?: string,
	renewalDate?: string
}

@Pipe({
	name: 'flyIsIndividualDatabaseSubscriptionActive'
})

export class IsIndividualDatabaseSubscriptionActive implements PipeTransform {
	transform(product: AvdbPricingProduct, activeSubscriptions: AvdbSubscription[]): SubscriptionStatus {
		if (activeSubscriptions == null || activeSubscriptions.length === 0) {
			return {isPurchased: false}
		}

		for (const subscription of activeSubscriptions) {
			if (product.partNumber === subscription.sku) {
				if (subscription.autorenewalEnabled) {
					return {
						isPurchased: true,
						autoRenewActive: true,
						renewalDate: formatDate(subscription.nextBillDate)
					}
				} else {
					return {
						isPurchased: true,
						autoRenewActive: false,
						endDate: formatDate(subscription.endDate)
					}
				}
			}
		}

		return {isPurchased: false}
	}
}
